export default "__VITE_ASSET__bFiUj7uX__"